import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=2a597efd&"
import script from "./Exception.vue?vue&type=script&lang=js&"
export * from "./Exception.vue?vue&type=script&lang=js&"
import style0 from "./Exception.vue?vue&type=style&index=0&id=2a597efd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports